"use client";

import { BountyErrorLayout } from "@/components/shared/bounty-error-layout";

export default function Error({
  error,
  reset,
}: {
  error: Record<string, string>;
  reset: () => void;
}) {
  return <BountyErrorLayout error={error} reset={reset} />;
}
